export const CarData = [{
    "type": "SEDAN",
    "carName": "G90",
    "engine": [
        { 
            "engineType": "가솔린 3.5터보",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "380" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "54.0" },
            "price": 0,
            "image": "g90-en.png"
        },
        { 
            "engineType":  "가솔린 3.5 터보 48V 일렉트릭 슈퍼차저",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "415" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "56.0" },
            "price": "6,000,000",
            "image": "g90-en.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)",
            "value": [
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "g90-23my-bto-exterior-uyuni-white-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-uyuni-white-desktop-1920x960"
                },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "g90-23my-bto-exterior-savile-silver-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-savile-silver-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "g90-23my-bto-exterior-makalu-gray-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-makalu-gray-desktop-1920x960"
                 },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "g90-23my-bto-exterior-vik-black-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-vik-black-desktop-1920x960" 
                },
                { 
                    "colorName": "마우이 블랙 [HBK]",
                    "color": "g90-23my-bto-exterior-maui-black-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-maui-black-desktop-1920x960"
                 },
                { 
                    "colorName": "한라산 그린 [MDY]",
                    "color": "g90-23my-bto-exterior-hallasan-green-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-hallasan-green-desktop-1920x960"
                 },
                { 
                    "colorName": "카프리 블루 [NRB]",
                    "color": "g90-23my-bto-exterior-capri-blue-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-capri-blue-desktop-1920x960"
                 },
                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "g90-23my-bto-exterior-uyuni-white-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-tasman-blue-desktop-1920x960"
                },
                { 
                    "colorName": "발렌시아 골드 [GLD]",
                    "color": "g90-23my-bto-exterior-tasman-blue-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-uyuni-white-desktop-1920x960"
                },
                { 
                    "colorName": "바릴로체 브라운 [BRB]",
                    "color": "g90-23my-bto-exterior-valencia-gold-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-valencia-gold-desktop-1920x960"
                }
            ],
            "price": "0"
        },
        {
            "type": "m",
            "material": "매트 (무광)",
            "value": [
                { 
                    "colorName": "베르비에 화이트 [NA3]",
                    "color": "g90-23my-bto-exterior-makalu-gray-matte-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-verbier-white-matte-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [MPE]",
                    "color": "g90-23my-bto-exterior-makalu-gray-matte-color-chip-160x160",
                    "car": "g90-23my-bto-exterior-sedan-makalu-gray-matte-desktop-1920x960"
                }
            ],
            "price": "800,000"
        }
    ],

    "innerDesign": [
        {
            "title": "스탠다드 시트(5인승)",
            "value": [],
            "image": "inner1.jpg",
            "price": "0"
        },
        {
            "title": "퍼스트 클래스 VIP 시트(4인승)",
            "value": [],
            "image": "inner2.jpg",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }


        ]
    }
    
    
},

{
    "type": "SEDAN",
    "carName": "G80",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType":  "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "380" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "54.0" },
            "price": "6,700,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)",
            "value": [
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "01_g80-23my-bto-exterior-uyuni-white-colorchip-160x160-kr",
                    "car": "01_g80-23my-bto-exterior-uyuni-white-desktop-1920x960-kr"
                },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "02_g80-23my-bto-exterior-savile-silver-colorchip-160x160-kr",
                    "car": "02_g80-23my-bto-exterior-savile-silver-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "03_g80-23my-bto-exterior-makalu-gray-colorchip-160x160-kr",
                    "car": "03_g80-23my-bto-exterior-makalu-gray-desktop-pc-1920x960-kr"
                 },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "04_g80-23my-bto-exterior-vik-black-colorchip-160x160-kr",
                    "car": "04_g80-23my-bto-exterior-vik-black-desktop-pc-1920x960-kr" 
                },

                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "05_g80-23my-bto-exterior-tasman-blue-colorchip-160x160-kr",
                    "car": "05_g80-23my-bto-exterior-tasman-blue-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "캐번디시 레드 [RLA]",
                    "color": "06_g80-23my-bto-exterior-cavendish-red-colorchip-160x160-kr",
                    "car": "06_g80-23my-bto-exterior-cavendish-red-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "한라산 그린 [MDY]",
                    "color": "07_g80-23my-bto-exterior-hallasan-green-colorchip-160x160-kr",
                    "car": "07_g80-23my-bto-exterior-hallasan-green-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "카프리 블루 [NRB]",
                    "color": "08_g80-23my-bto-exterior-capri-blue-colorchip-160x160-kr",
                    "car": "08_g80-23my-bto-exterior-capri-blue-desktop-1920x960-kr"
                },
                { 
                    "colorName": "발렌시아 골드 [GLD]",
                    "color": "09_g80-23my-bto-exterior-valencia-gold-colorchip-160x160-kr",
                    "car": "09_g80-23my-bto-exterior-valencia-gold-desktop-1920x960-kr"
                },
                { 
                    "colorName": "바릴로체 브라운 [BRB]",
                    "color": "10_g80-23my-bto-exterior-bariloche-brown-colorchip-160x160-kr",
                    "car": "10_g80-23my-bto-exterior-bariloche-brown-desktop-1920x960-kr"
                }
            ],
            "price": "0"
        },
        {
            "type": "m",
            "material": "매트 (무광)",
            "value": [
                { 
                    "colorName": "베르비에 화이트 [NA3]",
                    "color": "g80-23my-bto-exterior-verbier-white-matt-colorchip-160x160-kr",
                    "car": "01_g80-23my-bto-exterior-verbier-white-matt-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "본드 실버 [SMT]",
                    "color": "g80-23my-bto-exterior-bond-silver-matt-colorchip-160x160-kr",
                    "car": "02_g80-23my-bto-exterior-bond-silver-matt-desktop-1920x960-kr"
                },
                { 
                    "colorName": "마칼루 그레이 [MPE]",
                    "color": "g80-23my-bto-exterior-makalu-gray-matt-colorchip-160x160-kr",
                    "car": "03_g80-23my-bto-exterior-makalu-gray-matt-desktop-1920x960-kr"
                }
            ],
            "price": "700,000"
        }
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
},

{
    "type": "SEDAN",
    "carName": "G80_ELECTRIFIED",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType":  "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "380" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "54.0" },
            "price": "6,700,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)",
            "value": [
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "01_g80-23my-bto-exterior-uyuni-white-colorchip-160x160-kr",
                    "car": "01_g80-23my-bto-exterior-uyuni-white-desktop-1920x960-kr"
                },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "02_g80-23my-bto-exterior-savile-silver-colorchip-160x160-kr",
                    "car": "02_g80-23my-bto-exterior-savile-silver-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "03_g80-23my-bto-exterior-makalu-gray-colorchip-160x160-kr",
                    "car": "03_g80-23my-bto-exterior-makalu-gray-desktop-pc-1920x960-kr"
                 },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "04_g80-23my-bto-exterior-vik-black-colorchip-160x160-kr",
                    "car": "04_g80-23my-bto-exterior-vik-black-desktop-pc-1920x960-kr" 
                },

                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "05_g80-23my-bto-exterior-tasman-blue-colorchip-160x160-kr",
                    "car": "05_g80-23my-bto-exterior-tasman-blue-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "캐번디시 레드 [RLA]",
                    "color": "06_g80-23my-bto-exterior-cavendish-red-colorchip-160x160-kr",
                    "car": "06_g80-23my-bto-exterior-cavendish-red-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "한라산 그린 [MDY]",
                    "color": "07_g80-23my-bto-exterior-hallasan-green-colorchip-160x160-kr",
                    "car": "07_g80-23my-bto-exterior-hallasan-green-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "카프리 블루 [NRB]",
                    "color": "08_g80-23my-bto-exterior-capri-blue-colorchip-160x160-kr",
                    "car": "08_g80-23my-bto-exterior-capri-blue-desktop-1920x960-kr"
                },
                { 
                    "colorName": "발렌시아 골드 [GLD]",
                    "color": "09_g80-23my-bto-exterior-valencia-gold-colorchip-160x160-kr",
                    "car": "09_g80-23my-bto-exterior-valencia-gold-desktop-1920x960-kr"
                },
                { 
                    "colorName": "바릴로체 브라운 [BRB]",
                    "color": "10_g80-23my-bto-exterior-bariloche-brown-colorchip-160x160-kr",
                    "car": "10_g80-23my-bto-exterior-bariloche-brown-desktop-1920x960-kr"
                }
            ],
            "price": "0"
        },
        {
            "type": "m",
            "material": "매트 (무광)",
            "value": [
                { 
                    "colorName": "베르비에 화이트 [NA3]",
                    "color": "g80-23my-bto-exterior-verbier-white-matt-colorchip-160x160-kr",
                    "car": "01_g80-23my-bto-exterior-verbier-white-matt-desktop-1920x960-kr"
                 },
                { 
                    "colorName": "본드 실버 [SMT]",
                    "color": "g80-23my-bto-exterior-bond-silver-matt-colorchip-160x160-kr",
                    "car": "02_g80-23my-bto-exterior-bond-silver-matt-desktop-1920x960-kr"
                },
                { 
                    "colorName": "마칼루 그레이 [MPE]",
                    "color": "g80-23my-bto-exterior-makalu-gray-matt-colorchip-160x160-kr",
                    "car": "03_g80-23my-bto-exterior-makalu-gray-matt-desktop-1920x960-kr"
                }
            ],
            "price": "700,000"
        }
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
},

{
    "type": "SEDAN",
    "carName": "G70",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType": "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "370" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "52.0" },
            "price": "5,000,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)", 
            "value": [
                { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "g70-23my-bto-exterior-blazing-red-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-blazing-red-desktop-1920x960"
                },
                { 
                    "colorName": "카와 블루 [BLE]",
                    "color": "g70-23my-bto-exterior-bond-silver-matt-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-bond-silver-matte-desktop-1920x960"
                 },
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "g70-23my-bto-exterior-capri-blue-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-capri-blue-desktop-1920x960"
                 },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "g70-23my-bto-exterior-cavendish-red-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-cavendish-red-desktop-1920x960" 
                },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "g70-23my-bto-exterior-hallasan-green-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-hallasan-green-desktop-1920x960"
                 },
                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "g70-23my-bto-exterior-kawah-blue-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-kawah-blue-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "g70-23my-bto-exterior-makalu-gray-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-makalu-gray-desktop-1920x960"
                 },
                { 
                    "colorName": "블레이징 레드 [Z5E]",
                    "color": "g70-23my-bto-exterior-makalu-gray-matt-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-makalu-gray-matte-desktop-1920x960"
                },
                { 
                    "colorName": "캐번디시 레드 [RLA]",
                    "color": "g70-23my-bto-exterior-savile-silver-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-savile-silver-desktop-1920x960"
                },
                { 
                    "colorName": "카프리 블루 [NRB]",
                    "color": "g70-23my-bto-exterior-tasman-blue-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-tasman-blue-desktop-1920x960"
                },
                { 
                    "colorName": "한라산 그린 [MDY]",
                    "color": "g70-23my-bto-exterior-uyuni-white-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-uyuni-white-desktop-1920x960"
                }
            ],
            "price": "0"
        },
        {
            "type": "m",
            "material": "매트 (무광)",
            "value": [
                { 
                    "colorName": "베르비에 화이트 [NA3]",
                    "color": "g70-23my-bto-exterior-vatna-gray-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-vatna-gray-desktop-1920x960"
                 },
                { 
                    "colorName": "본드 실버 [SMT]",
                    "color": "g70-23my-bto-exterior-verbier-white-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-verbier-white-matte-desktop-1920x960"
                },
                { 
                    "colorName": "마칼루 그레이 [MPE]",
                    "color": "g70-23my-bto-exterior-vik-black-color-chip-160x160",
                    "car": "g70-23my-bto-exterior-vik-black-desktop-1920x960"
                }
            ],
            "price": "700,000"
        }
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
},

{
    "type": "SUV",
    "carName": "GV60",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType": "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "370" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "52.0" },
            "price": "5,000,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)", 
            "value": [
                { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "gv60-23my-bto-exterior-uyh-uyuni-white-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-uyuni-white-desktop-1920x960"
                },
                { 
                    "colorName": "카와 블루 [BLE]",
                    "color": "gv60-23my-bto-exterior-sss-savile-silver-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-savile-silver-desktop-1920x960"
                 },
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "gv60-23my-bto-exterior-emt-hanauma-mint-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-hanauma-mint-desktop-1920x960"
                 },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "gv60-23my-bto-exterior-cpm-atacama-copper-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-atacama-copper-desktop-1920x960" 
                },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "gv60-23my-bto-exterior-cpr-atacama-copper-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-atacama-copper-matt-desktop-1920x960"
                 },
                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "gv60-23my-bto-exterior-ph3-vik-black-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-vik-black-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "gv60-23my-bto-exterior-ncm-makalu-gray-colorchip-160x160",
                    "car": "gv60-23my-bto-exterior-makalu-gray-desktop-1920x960"
                 },
            ],
            "price": "0"
        },
       
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
},

{
    "type": "SUV",
    "carName": "GV70",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType": "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "370" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "52.0" },
            "price": "5,000,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)", 
            "value": [
                { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "gv70-22my-bto-exterior-barossa-burgundy-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-barossa-burgundy-desktop-1920x960"
                },
                { 
                    "colorName": "카와 블루 [BLE]",
                    "color": "gv70-22my-bto-exterior-barossa-burgundy-matt-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-barossa-burgundy-matt-desktop-1920x960"
                 },
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "gv70-22my-bto-exterior-capri-blue-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-capri-blue-desktop-1920x960"
                 },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "gv70-22my-bto-exterior-makalu-gray-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-makalu-gray-desktop-1920x960" 
                },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "gv70-22my-bto-exterior-matterhorn-white-matt-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-matterhorn-white-matt-desktop-1920x960"
                 },
                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "gv70-22my-bto-exterior-mauna-red-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-mauna-red-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "gv70-22my-bto-exterior-savile-silver-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-savile-silver-desktop-1920x960"
                 },
                 { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "gv70-22my-bto-exterior-savile-silver-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-savile-silver-desktop-1920x960"
                },
                { 
                    "colorName": "카와 블루 [BLE]",
                    "color": "gv70-22my-bto-exterior-uyuni-white-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-uyuni-white-desktop-1920x960"
                 },
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "gv70-22my-bto-exterior-vik-black-color-chip-160x160",
                    "car": "gv70-22my-bto-exterior-vik-black-desktop-1920x960"
                 },
            ],
            "price": "0"
        },
       
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
},

{
    "type": "SUV",
    "carName": "GV80",
    "engine": [
        { 
            "engineType": "가솔린 2.5T",
            "cc": { "title": "배기량(cc)", "value": "2,497" },
            "ps": { "title": "최고출력(ps)", "value": "304" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "43.0" },
            "price": 0,
            "image": "engin1.png"
        },
        { 
            "engineType": "가솔린 3.5T",
            "cc": { "title": "배기량(cc)", "value": "3,470" },
            "ps": { "title": "최고출력(ps)", "value": "370" },
            "kgfm": { "title": "최대토크(kgf-m)", "value": "52.0" },
            "price": "5,000,000",
            "image": "engin2.png"
        }
    ],

    "outerColor": [
        {
            "type": "u",
            "material": "글로시 (유광)", 
            "value": [
                { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-bjk-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-barossa-burgundy-desktop-1920x960"
                },
                { 
                    "colorName": "카와 블루 [BLE]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-bjm-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-barossa-burgundy-matte-desktop-1920x960"
                 },
                { 
                    "colorName": "우유니 화이트 [UYH]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-ft7-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-savile-silver-desktop-1920x960"
                 },
                { 
                    "colorName": "세빌 실버 [SSS]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-mpe-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-capri-blue-desktop-1920x960" 
                },
                { 
                    "colorName": "비크 블랙 [PH3]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-ncm-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-makalu-gray-desktop-1920x960"
                 },
                { 
                    "colorName": "태즈먼 블루 [URA]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-uyh-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-uyuni-white-desktop-1920x960"
                 },
                { 
                    "colorName": "마칼루 그레이 [NCM]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-ph3-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-vik-black-desktop-1920x960"
                 },
                 { 
                    "colorName": "바트나 그레이 [GRY]",
                    "color": "genesis-kr-models-gv80-23my-bto-exterior-colorchip-rjk-desktop-160x160",
                    "car": "gv80-23my-bto-exterior-mauna-red-desktop-1920x960"
                },
              
            ],
            "price": "0"
        },
       
    ],

    "innerDesign": [
        {
            "title": "스탠다드 디자인",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "0"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 1",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "15,500,000"
        },
        {
            "title": "시그니쳐 디자인 셀렉션 2",
            "value": [
                { 
                    "colorName": "옵시디언 블랙 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-black-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "하바나 브라운 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds1-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds1-blue-pc-1920x960-kr.jpg"
                 },
                { 
                    "colorName": "포레스트 블루 모노톤",
                    "color": "g80-23my-bto-interior-standard-sds2-blue-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-sds2-blue-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 듄 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-black-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-black-pc-1920x960-kr.jpg"
                 },
                 { 
                    "colorName": "안트라사이트 그레이 / 바닐라 베이지 투톤",
                    "color": "g80-23my-bto-interior-standard-std-brown-colorchip-160x160-kr.jpg",
                    "inner": "g80-23my-bto-interior-standard-std-brown-pc-1920x960-kr.jpg"
                 }
            ],
            "image": "",
            "price": "3,500,000"
        }
    ],

    "option": {
        "type": [
            {
                "title": "파퓰러 컬렉션",
                "price": "8,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2",
                "price": "11,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "뒷좌석 컴포트 패키지 2"]
            },
            {
                "title": "파퓰러 컬렉션 + 이지 클로즈 시스템",
                "price": "10,000,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 1", "하이테크 패키지", "이지 클로즈 시스템"]
            },
            {
                "title": "파퓰러 컬렉션 + 뒷좌석 컴포트 패키지 2 + 이지 클로즈 시스템",
                "price": "12,500,000",
                "packageValue": ["컨비니언스 패키지", "뒷좌석 컴포트 패키지 I", "하이테크 패키지", "뒷좌석 컴포트 패키지 2", "이지 클로즈 시스템"]
            }
        ],
        "package": [
            { 
                "packName": "컨비니언 패키지",
                "image": "option1.jpg",
                "conts": {
                    "con1": "운전석 에르고 릴렉싱 시트(22방향, 마사지, 볼스터 포함), 동승석 에르고 릴렉싱 시트(20방향, 마사지, 볼스터 포함), 고스트 도어 클로징, 무드 큐레이터(향기 카트리지 3EA 포함)를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 1",
                "image": "option2.jpg",
                "conts": {
                    "con1": "뒷좌석 승객을 배려한 뒷좌석 전동 시트(16방향), VIP 좌석 레그레스트(토퍼 1EA 포함), 뒷좌석 통풍 시트, 어드밴스드 3존 공조(B필러 에어벤트), 뒷좌석 목베개(2EA), 뒷좌석 윙아웃 헤드레스트, 뒷좌석 스마트폰 무선 충전 기능이 포함되어 있습니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "하이테크 패키지",
                "image": "option3.jpg",
                "conts": {
                    "con1": "운전자의 안전과 편의를 위한 헤드업 디스플레이와 지능형 헤드램프를 포함한 옵션 패키지입니다.",
                    "con2": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다." 
                }
            },
            { 
                "packName": "뒷좌석 컴포트 패키지 2",
                "image": "option6.jpg",
                "conts": {
                    "con1": "뒷좌석 에르고 릴렉싱 시트(뒷좌석 마사지, VIP 좌석 발 마사지), VIP 좌석 풋레스트 (토퍼 1EA 포함), 뒷좌석 프라이버시 글라스를 포함한 옵션 패키지입니다.",
                    "con2": "※ 뒷좌석 컴포트 패키지 I 선택 시 선택 가능합니다.",
                    "con3": "※ 뒷좌석 컴포트 패키지 II 와 컨비니언스 패키지 동시 선택 시 동승석 일부 기능(럼버 서포트, 볼스터, 마사지, 쿠션 지지 조절)이 적용되지 않습니다.",
                    "con4": "※ 상기 이미지는 풀옵션 기준 대표 이미지입니다. 추천 사양의 상세 사양 구성은 개별 선택 옵션과 동일하며, 상세 내용은 개별 선택 옵션 페이지를 참조하시길 바랍니다."
                }
            },
            { 
                "packName": "이지 클로즈 시스템",
                "image": "option5.jpg",
                "conts": {
                    "con1": "승차 후 손을 뻗어 도어를 당길 필요 없이 편안하게 앉은 상태에서 콘솔의 버튼을 누르면 도어가 부드럽게 닫힙니다. 하차할 때는 도어 트림의 버튼을 누르고 가볍게 미는 동작으로 도어가 손쉽게 열립니다."
                }
            }
        ]
    }
    
    
    
}




] 